import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MantineProvider, ColorSchemeScript } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import './i18n';

const injectUmamiForTauriApp = () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  const isTauri =
    typeof (window as any).__TAURI__ !== 'undefined' ||
    typeof (window as any).__TAURI_INTERNALS__ !== 'undefined';

  if (!isTauri) return;
  if (document.querySelector('script[data-umami="true"]')) return;

  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://umami.kalimatai.com/script.js';
  script.setAttribute('data-website-id', '33668b22-c77b-4769-8bc2-d7266797dc55');
  script.setAttribute('data-umami', 'true');

  document.head.appendChild(script);
};

// Function to get initial color scheme from localStorage or system preference
const getInitialColorScheme = () => {
  if (typeof window !== 'undefined') {
    // Check for user preference in localStorage
    const storedPreference = localStorage.getItem('mantine-color-scheme');
    if (storedPreference) {
      return storedPreference;
    }
    
    // Check for system preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
  }
  
  // Default to light if no preference is found
  return 'light';
};

// Apply the initial color scheme to the document.documentElement immediately
const initialColorScheme = getInitialColorScheme();
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-mantine-color-scheme', initialColorScheme);
}

injectUmamiForTauriApp();

// Simple health check endpoint for Docker
if (typeof window === 'undefined') {
  // This won't run in the browser, but shows the concept
  // In a full implementation, this would be handled by the server
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme={initialColorScheme}>
      <ColorSchemeScript defaultColorScheme={initialColorScheme} />
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </React.StrictMode>,
);